<template>
  <div class="container py-5 mx-auto md-layout">
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <a href="/legal/privacy">&larr; Back to Privacy Portal</a>
    </div>
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <h1>Cookie policy</h1>
      <p>
        By using ArtistHub websites (artisthub.io and vibe.to) you agree to this
        policy and consent to our use of cookies in accordance with the
        following terms. You may manage your cookie settings using the ArtistHub
        website.
      </p>
      <h2>Introduction to cookies</h2>
      <p>
        A cookie is a small piece of data stored on the user's computer by the
        web browser while browsing a website. Cookies were designed to be a
        reliable mechanism for websites to remember stateful information or to
        record the user's browsing activity.
      </p>
      <h2>How ArtistHub uses cookies</h2>
      <p>
        ArtistHub cookies don't hold any detail that identifies you
        individually. However, we can connect the personal information we store
        about you with the information stored in, and obtained from, cookies.
        The cookies used on ArtistHub websites are purely required for entry and
        navigation, monitor use, remember your choices, and deliver personalized
        content or ads to you.
      </p>
      <p>
        We may use the information we obtain from your use of our cookies for
        the following purposes:
      </p>
      <ol>
        <li>to recognize you when you visit our websites</li>
        <li>to improve website usability</li>
        <li>to analyze use of our websites</li>
        <li>in the administration of our websites</li>
        <li>to personalize the website</li>
        <li>to deliver relevant and personalzed advertiesments</li>
      </ol>
      <p>
        Depending on which ArtistHub website you visit and your privacy
        preferences, we may use session cookies, persistent cookies, and
        third-party cookies.
      </p>
      <h2>Opt-out of ArtistHub cookies</h2>
      <p>
        If you prefer that we do not collect non-personally identifiable
        information about your visits for the purpose of delivering targeted
        advertising, you may opt out using our
        <a href="/legal/privacy/">opt-out tool</a>.
      </p>
      <p>
        When you opt out, we place an opt-out cookie on your computer that tells
        us not to collect your information for delivering relevant online
        advertisements on vibe.to. Please note that if you delete, block, or
        otherwise restrict cookies, or use a different computer or Internet
        browser, you will need to renew your opt-out choice.
      </p>
      <h2>Managing ArtistHub cookies</h2>
      <p>
        The majority of browsers allow you to block and delete cookies. This
        process may differ among browsers and operating systems, so please refer
        to the latest support materials of your browser for more information.
        Blocking or deleting cookies can have a detrimental influence on the
        accessibility of ArtistHub websites, leaving you unable to access core
        features and functionality.
      </p>
      <h2>Contact ArtistHub</h2>
      <p>
        The ArtistHub websites are owned and operated by Artist Hub Inc, a
        company registered in Florida. If you have any questions or comments
        about this Cookie Policy, you may email us at privacy@artisthub.io
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
